<template>
  <div>

   <div class="d-flex justify-content-between">
     <b-col cols="2">
       <b-button class="btnFilter shadow px-3"
                 @click="refreshInbox()">
         <i class="fa-light fa-rotate-right "></i>
         {{ $t('common.rfrsh') }}
       </b-button>
     </b-col>
     <b-col cols="2">
       <b-button class="btnFilter_2 shadow" v-if="TestCaseTBList.length > 0"
         @click="chooseExtractType()">
         <i class="fa-light fa-upload fs-14px"></i>
         <span class="fab-label">{{ $t('common.extract_page') }}</span>
       </b-button>
     </b-col>
    </div>
    <spinner v-if="activateSpinner"></spinner>
    <div v-else-if="TestCaseTBList.length > 0" >
      <chart-pie-stat :stat="TestCaseTBList" class="p-5 mt-5 bg-light shadow" style="border-radius: 20px"></chart-pie-stat>

      <form-accordion
          class="px-5 pt-4 py-3 my-5 bg-light shadow" style="border-radius: 20px"
          :open="false"
          :showArrow="false"
          v-for="(testCase, index) in TestCaseTBList"
          :key="index"
          :title="`Test ${index + 1} : ${getTestCaseName(testCase.CaseSumary)}`"
          titleClass="col-4"
          titleClassContainer="justify-content-between"
          :isTitleUpperCase="false" keepSummary keepSummaryCenter>
        <template #summaryCenter>
          <div class="text-ellipsis d-flex">
          <b-table hover
                   class="table table-striped"
                   style="margin-bottom:0"
                   :fields="fieldsDataSet"
                   :items="[testCase]"
                   :empty-text="$t('common.security.no_result')">
            <template #cell(KO)="data">
              <div class="text-ellipsis">{{ data.item.LineTestCaseKo ? data.item.LineTestCaseKo : '-' }}</div>
            </template>
            <template #cell(OK)="data">
              <div class="text-ellipsis">{{ data.item.TestCaseOk ? data.item.TestCaseOk : '-' }}</div>
            </template>
            <template #cell(CONF_NOT_FOUND)="data">
              <div class="text-ellipsis">{{ data.item.LineTestCaseMc ? data.item.LineTestCaseMc : '-' }}</div>
            </template>
            <template #cell(NULL)="data">
              <div class="text-ellipsis">{{ data.item.LineTestCaseNull ? data.item.LineTestCaseNull : '-' }}</div>
            </template>
          </b-table>
          </div>
        </template>
        <template #summary>
          <div class="text-ellipsis d-flex">
            <div class="mx-3 d-flex">
              <label class="mr-2">Status:</label>
              <span>
                <i :title="chooseStatusTitle(testCase.Status)" :class="chooseStatusIcon(testCase.Status)" class="d-flex align-items-center justify-content-center fas rounded-circle" style="width: 20px; height: 20px;"/>
              </span>
              <!-- <span>{{ testCase.Status ? $t('tracking.testcase_status_list.' + testCase.Status) : 'N/A' }}</span> -->
            </div>
          </div>
        </template>
<!--        <b-table hover-->
<!--                 class="table table-striped"-->
<!--                 style="margin-bottom:0"-->
<!--                 :fields="fields"-->
<!--                 :items="[testCase]"-->
<!--                 :empty-text="$t('common.security.no_result')">-->
<!--          <template #cell(DescriptionCase)="data">-->
<!--            <div class="text-ellipsis">Test Data {{ data.item.IdDataset }} : {{ data.value ? data.value : '-' }}</div>-->
<!--          </template>-->
<!--          <template #cell(Status)="data">-->
<!--            <span class="d-flex align-items-center justify-content-center align-baseline">-->
<!--              <i :title="chooseStatusTitle(testCase.Status)" :class="chooseStatusIcon(testCase.Status)" class="fas rounded-circle"/>-->
<!--            </span>-->
<!--          </template>-->
<!--          <template #cell(ExecutionDate)="data">-->
<!--            <div class="text-ellipsis">{{ data.item.ExecutionDate ? getDate(data.item.ExecutionDate) : '-' }}</div>-->
<!--          </template>-->
<!--        </b-table>-->
      </form-accordion>
    </div>
    <div v-else class="d-flex justify-content-center">
      <span class="noResult">
        {{ $t('common.no_result') }}
      </span>
    </div>
    <b-row class="mt-5">
      <b-col cols="12">
        <cm-pagination
          :maxResultsByPage="paginationObject.maxResults"
          :firstIndex="paginationObject.firstIndex"
          :nbResultsTotal="paginationObject.nbResultsTotal"
          :refreshEvent="paginationObject.refresh">
        </cm-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import BackButton from "@/components/common/backButton.vue"
import ChartPieStat from "@/pages/testCaseReport/ChartPieStat.vue"
import FormAccordion from "@/components/common/FormAccordion.vue"
import { jsPDF } from "jspdf"
import "jspdf-autotable"
import moment from "moment/moment"
import EPCLogo from '@/assets/EPC_logo.png'


export default {
  name: 'TestCaseReportList',
  components: {
    FormAccordion,
    ChartPieStat,
    BackButton,
    'cm-pagination': Pagination,
    'spinner': Spinner,
    'datetime-picker-custom': dateTimePicker,
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    type: {
      default: 'DDV',
      type: String
    },
    id: {
      default: 'NULL',
      type: String
    }
  },
  computed: {
    fields () {
      let fields
      fields = [
        { key: 'DescriptionCase', label: this.$i18n.t('injection_tab.test_case.case_description'), class: 'text-center', sortable: false },
        { key: 'Status', label: this.$i18n.t('account_tb.status_report'), class: 'text-center', sortable: false },
        { key: 'ExecutionDate', label: this.$i18n.t('account_tb.execution_date'), class: 'text-center', sortable: false },
      ]

      return fields
    },
    fieldsDataSet () {
      let fields
      fields = [
        { key: 'KO', label: this.$i18n.t('account_tb.status.KO'), class: 'text-center', sortable: false },
        { key: 'OK', label: this.$i18n.t('account_tb.status.OK'), class: 'text-center', sortable: false },
        { key: 'CONF_NOT_FOUND', label: this.$i18n.t('account_tb.status.CONF_NOT_FOUND'), class: 'text-center', sortable: false },
        { key: 'NULL', label: this.$i18n.t('account_tb.status.NULL'), class: 'text-center', sortable: false },
      ]

      return fields
    },
    company_nameDirection () {
      return ((this.sortField === 'company_name' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    statusVerificationDirection () {
      return ((this.sortField === 'statusVerification' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    activeDirection () {
      return ((this.sortField === 'active' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    hasInputFilter () {
      if (
          this.Name ||
          this.Result ) {
        return true
      }
      return false
    },
  },
  data () {
    return {
      TestCaseTBList: {
        type: Array,
        required: true
      },
      isMandatoryFieldMiss: true,
      activateSpinner: false,
      displayFilter: false,
      filterBy: '',
      hasDefaultFilter: false,
      statusVerification: '',
      VopProvider: '',
      Result: '',
      Name: '',
      CIT: {BICC: "0", LEIC: "0", SCHEME_NAME_CODE: "0", SCHEME_NAME_PROPRIETARY: "0"},
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true,
      sortDirection: 'DESC',
      sortField: 'dateAction',
    }
  },
  created () {
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start',
      navTitle: 'Tracking',
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.onRefresh(false, index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)

    this.filterTypeGet = this.filterType
    this.$bus.emit('right-panel-set-feature', 'filter-messages')
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  beforeDestroy () {
    let that = this
    that.$engine.tracking.cleanFilterCondition()
  },
  methods: {
    activateDetail (id) {
      let that = this
      loadPage(that, {url: '/accountTBdetails/' + id})
    },
    applyFilter (filterConditions = {}) {
      if(this.tabName !== 2 && this.dateBegin === ''){
        this.isMandatoryFieldMiss = false
        return
      }
      this.isMandatoryFieldMiss = false
      this.TestCaseTBList = []
      let that = this
      this.filterTypeGet = 'list'

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0
      this.activateSpinner = true
      this.$engine.tracking.cleanFilterCondition()

      filterConditions.Name = this.Name.trim()

      this.$engine.accountTB.getAccountTB(
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResultsTotal = resp.data.countTestCaseTBs
        that.paginationObject.nbResults = resp.data.accounts.length
        requests = resp.data.accounts
        that.updateInbox(requests)
        // this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    attachInfinit () {
      if (this.$settings.inboxPreloaderRemoved ||
          this.$settings.sendboxPreloaderRemoved) {
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.settings.set({inboxPreloaderRemoved: false})
      }
      this.scrollFlag = true
      this.noMore = false
    },
    chooseExtractType () {
      let that = this
      this.$f7.modal({
        title: that.$t('account_tb.choose_extract_type'),
        buttons: [
          {
            text: 'CSV',
            onClick: function () {
              that.extractCSV()
            }
          },
          {
            text: 'PDF',
            onClick: function () {
              that.generatePDF()
            }
          },
          {
            text: that.$i18n.t('common.cncl'),
            onClick: function () {
            }
          }
        ]
      })
    },
    chooseStatusTitle (status) {
      switch (status) {
        case '0':
          return 'KO';
        case '2':
          return 'OK';
        case '3':
          return 'Missing configuration';
        case '4':
          return 'Pending';
        default:
          return 'N/A'
      }
    },
    chooseStatusIcon (status) {
      switch (status) {
        case '0':
          return 'fa-times bg-danger text-white';
        case '2':
          return 'fa-check bg-success text-white';
        case '3':
          return 'fa-file-alt bg-secondary text-white';
        case '4':
          return 'fa-hourglass-half bg-secondary text-white';
        default:
          return 'fa-minus bg-secondary text-white'
      }
    },
    clearFilterFields () {
      this.isMandatoryFieldMiss = true
      this.paginationObject = {}
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['maxResults'] = 15
      this.paginationObject['nbResultsTotal'] = 0
      this.paginationObject['refresh'] = 'direct-inbox-filtered'
      this.Name = ''
      this.communicateChange()
      this.TestCaseTBList = []
      this.applyFilter()
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.settings.set({inboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    extractCSV () {
      let that = this
      that.$engine.usercompany.idUserAcc = this.idUserAcc
      this.UsersList = []
      let filterConditions = {
        Report: 1,
      }
      that.$engine.accountTB.getTestTB(
          filterConditions
      )
      .then(resp => {
        let csvContent = ''

        let firstLine = this.$i18n.t('account_tb.type') + ';' +
          this.$i18n.t('account_tb.test_case_id') + ';' +
          this.$i18n.t('account_tb.description') + ';' +
          this.$i18n.t('account_tb.status_report') + ';' +
          this.$i18n.t('account_tb.execution_date')

        let lines = [firstLine]
        if (resp.data && resp.data.Tests) {
          resp.data.Tests.sort((a, b) => {
            return that.getTestCaseName(a.CaseSumary) > that.getTestCaseName(b.CaseSumary) ? 1 : -1
          }).forEach(test => {
            let status = test.Status != '' ? this.$i18n.t('tracking.testcase_status_list.'+ test.Status) : this.$t('toolbox.filtre_status_pending')
            let execution_date = test.ExecutionDate != '' ? moment.utc(test.ExecutionDate).local().format('YYYY-MM-DD HH:mm:ss.SSS') : this.$i18n.t('account_tb.status.NULL')
            let line = test.Type.toUpperCase() + ';' + test.IdTestCase + ';' + this.getTestCaseName(test.CaseSumary) + ';' + status + ';' + execution_date
            lines.push(line)
          })
        }
        const linkSource = 'data:text/csv;charset=utf-8,' + encodeURIComponent(lines.join("\n"))
        const downloadLink = document.createElement('a')
        const fileName = this.$t('account_tb.report_test_cases_pdf') + '_' + moment().format('YYYYMMDDHHmmss') + '.csv'
        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()

        this.$f7.alert('', this.$i18n.t('account_tb.exprt_succ', {filename: fileName}))
      })
      .catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    fetchTestTB() {
      this.pageCounter = 0
      this.activateSpinner = true
      let that = this
      that.$engine.usercompany.idUserAcc = this.idUserAcc
      this.UsersList = []
      let filterConditions = {
        Report: 1,
      }
      that.$engine.accountTB.getTestTB(
          filterConditions
      )
          .then(resp => {
            this.CIT = resp.data.CIT
            this.TestCaseTBList = resp.data.Tests.sort((a, b) => {
              return that.getTestCaseName(a.CaseSumary) > that.getTestCaseName(b.CaseSumary) ? 1 : -1
            }) || []
            this.activateSpinnerTest = false

            that.activateSpinner = false
          })
          .catch(error => {
            this.activateSpinner = false
            errorMessageAlert(error, that, that.$i18n)
          })
    },
    generatePDF () {
      function getValidDate(dateStr) {
        if (!dateStr || typeof dateStr !== 'string' || dateStr.trim() === '') return null;
        const date = new Date(dateStr);
        return isNaN(date.getTime()) ? null : date;
      }

      function getStatusLabel(status, context) {
        switch (status) {
          case '0': return context.$t('toolbox.filtre_status_ko')
          case '2': return context.$t('toolbox.filtre_status_ok')
          case '3': return context.$t('account_tb.status.CONF_NOT_FOUND')
          case 'NULL':
            return context.$t('toolbox.filtre_status_pending')
          default:
            return context.$t('toolbox.filtre_status_pending')
        }
      }

      function summarizeByStatus(testCases) {
        const summary = {
          OK: 0,
          KO: 0,
          CONF_NOT_FOUND: 0,
          PENDING: 0
        }

        testCases.forEach(tc => {
          switch (tc.Status) {
            case '2': summary.OK++; break
            case '0': summary.KO++; break
            case '3': summary.CONF_NOT_FOUND++; break
            default:
              summary.PENDING++; break
          }
        })

        return summary
      }

      function computeGlobalStatus(data, type) {
        const now = new Date();
        const groupedByTestCase = {};

        data.forEach(item => {
          if (item.Type !== type || !item.IdTestCase || !item.IdDataset) return;

          const date = getValidDate(item.ExecutionDate);
          const testCaseId = item.IdTestCase;
          const datasetId = item.IdDataset;

          if (!groupedByTestCase[testCaseId]) {
            groupedByTestCase[testCaseId] = new Map();
          }

          const datasetMap = groupedByTestCase[testCaseId];

          if (!datasetMap.has(datasetId)) {
            datasetMap.set(datasetId, item);
          } else {
            const current = datasetMap.get(datasetId);
            const currentDate = getValidDate(current.ExecutionDate);
            if (!currentDate || (date && Math.abs(date - now) < Math.abs(currentDate - now))) {
              datasetMap.set(datasetId, item);
            }
          }
        });

        const results = [];

        Object.entries(groupedByTestCase).forEach(([testCaseId, datasetMap]) => {
          let status = 'NULL';

          for (const item of datasetMap.values()) {
            const statusCode = parseInt(item.Status, 10);
            if (statusCode === 0) {
              status = '0'; break;
            } else if (statusCode === 1 && type === 'req') {
              if (status !== 'KO') status = '1';
            } else if (statusCode === 3 && type === 'resp') {
              if (!['KO'].includes(status)) status = '3';
            } else if (statusCode === 2) {
              if (!['KO', 'CONF_NOT_FOUND'].includes(status)) status = '2';
            }
          }

          const firstItem = Array.from(datasetMap.values())[0];

          results.push({
            ...firstItem,
            ExecutionDate: getValidDate(firstItem.ExecutionDate) ? firstItem.ExecutionDate : '-',
            Status: status
          });
        });

        return results;
      }

      const doc = new jsPDF();
      const info = this.$engine.accounts.get();
      const userAccounts = info[0].userAccts;
      const userAccountId = info[0].userAccountId;
      const userAccount = userAccounts.find(account => account.id === userAccountId);
      const userLogin = userAccount.login;
      const companyName = this.$engine.user.get().name;
      const exportDate = new Date().toLocaleDateString();

      this.svgToBase64Image(EPCLogo)
          .then((logoDataUrl) => {
            const pageWidth = doc.internal.pageSize.getWidth();
            const logoWidth = 60;
            const logoX = (pageWidth - logoWidth) / 2 - 5;
            const logoY = 50;

            doc.addImage(logoDataUrl, 'JPG', logoX, logoY, logoWidth, 60);
            doc.setFontSize(18);
            doc.text(this.$t('account_tb.report_test_cases'), pageWidth / 2, logoY + 65, { align: 'center' });
            doc.setFontSize(10);
            doc.text(`Exported on ${exportDate}`, pageWidth / 2, logoY + 75, { align: 'center' });
            doc.text(`by ${userLogin} - ${companyName}`, pageWidth / 2, logoY + 80, { align: 'center' });

            doc.addPage();
            let yOffset = 25;

            doc.setFontSize(16)
            doc.setTextColor(0, 0, 0)
            doc.text(this.$t('account_tb.cit_activation_status'), 14, yOffset)
            yOffset += 10

            const citList = Object.entries(this.CIT || {})
            const citTable = citList.map(([citName, value]) => [
              citName,
              value === '1' ? this.$t('account_tb.activated') : this.$t('account_tb.deactivated')
            ])

            doc.autoTable({
              head: [[this.$t('account_tb.cit_name'), this.$t('account_tb.cit_status')]],
              body: citTable,
              startY: yOffset,
              theme: "grid",
              margin: { left: 14, right: 14 },
              styles: { fontSize: 10 }
            })

            yOffset = doc.lastAutoTable.finalY + 10
            doc.setFontSize(18)
            doc.text(this.$t('account_tb.report_test_cases'), pageWidth / 2, logoY + 65, { align: 'center' });
            const reqProcessed = computeGlobalStatus(this.TestCaseTBList, 'req');
            const respProcessed = computeGlobalStatus(this.TestCaseTBList, 'resp');

            const reqSummary = summarizeByStatus(reqProcessed);
            const respSummary = summarizeByStatus(respProcessed);

            const allStatuses = [
              ...Object.values(reqSummary),
              ...Object.values(respSummary)
            ]

            function isAllOK(summary) {
              return (
                  summary.PENDING === 0 &&
                  summary.KO === 0 &&
                  summary.CONF_NOT_FOUND === 0 &&
                  summary.OK > 0
              );
            }

            const allArePending = isAllOK(reqSummary) && isAllOK(respSummary)

            doc.setFontSize(16);
            doc.text(this.$t('account_tb.status_summary_title'), 14, yOffset);
            yOffset += 10

            const summaryTable = [
              [
                this.$t('account_tb.type_case'),
                this.$t('toolbox.filtre_status_ok'),
                this.$t('toolbox.filtre_status_ko'),
                this.$t('account_tb.status.CONF_NOT_FOUND'),
                this.$t('toolbox.filtre_status_pending')
              ],
              [
                this.$t('account_tb.type_case_req'),
                reqSummary.OK,
                reqSummary.KO,
                reqSummary.CONF_NOT_FOUND,
                reqSummary.PENDING
              ],
              [
                this.$t('account_tb.type_case_resp'),
                respSummary.OK,
                respSummary.KO,
                respSummary.CONF_NOT_FOUND,
                respSummary.PENDING
              ]
            ]

            const pageWidthArray = doc.internal.pageSize.getWidth()
            const margin = 14
            const availableWidth = pageWidthArray - margin * 2

            const firstColumnWidth = availableWidth * 0.2
            const otherColumnWidth = (availableWidth - firstColumnWidth) / 5

            doc.autoTable({
              head: [summaryTable[0]],
              body: summaryTable.slice(1),
              startY: yOffset,
              theme: 'grid',
              margin: { left: margin, right: margin },
              styles: { fontSize: 10 },
              columnStyles: {
                0: { cellWidth: firstColumnWidth },
                1: { cellWidth: otherColumnWidth },
                2: { cellWidth: otherColumnWidth },
                3: { cellWidth: otherColumnWidth },
                4: { cellWidth: otherColumnWidth },
                5: { cellWidth: otherColumnWidth }
              }
            })


            yOffset = doc.lastAutoTable.finalY + 10;
            if (allArePending) {
              doc.setFontSize(12);
              doc.setTextColor(0, 128, 0)
              doc.setFont("times", "bold")
              const message = this.$t('account_tb.all_cases_are_pending_message');
              const pageWidth = doc.internal.pageSize.getWidth();
              const textWidth = pageWidth - 28; // 14px de marge de chaque côté

              const lines = doc.splitTextToSize(message, textWidth);
              doc.setFontSize(64);
              doc.setTextColor(0, 167, 108); // vert
              doc.text(lines, 40, yOffset+100);
              doc.setTextColor(0, 0, 0); // reset noir
              yOffset += lines.length * 6;
              doc.setTextColor(0, 0, 0); // reset noir
            }
            doc.setFont("helvetica", "normal")
            doc.addPage();
            yOffset = 25;


            const allProcessed = [...reqProcessed, ...respProcessed];
            const groupedTestCases = {};

            allProcessed.forEach(testCase => {
              const key = `${testCase.IdTestCase}_${testCase.Type}`;
              if (!groupedTestCases[key]) {
                const summaryKey = testCase.CaseSumary;
                const i18nSummary = this.$i18n.t(`toolbox.${testCase.Type}_summary_case.${summaryKey}`);
                const caseSummary = i18nSummary !== `toolbox.${testCase.Type}_summary_case.${summaryKey}` ? i18nSummary : 'N/A';

                groupedTestCases[key] = {
                  IdTestCase: testCase.IdTestCase,
                  CaseSumary: caseSummary,
                  Type: testCase.Type,
                  Status: testCase.Status,
                  ExecutionDate: testCase.ExecutionDate && testCase.ExecutionDate !== '-'
                      ? moment.utc(testCase.ExecutionDate).format('YYYY-MM-DD HH:mm:ss.SSS')
                      : '-',
                  Datasets: []
                };
              }

              const descriptionKey = `${testCase.CaseSumary}_description`;
              const i18nDesc = this.$i18n.t(`toolbox.${testCase.Type}_description_case.${descriptionKey}`);
              const description = i18nDesc !== `toolbox.${testCase.Type}_description_case.${descriptionKey}` ? i18nDesc : 'N/A';

              groupedTestCases[key].Datasets.push([
                testCase.IdDataset,
                description,
                getStatusLabel(testCase.Status, this),
                testCase.ExecutionDate && testCase.ExecutionDate !== '-'
                    ? moment.utc(testCase.ExecutionDate).format('YYYY-MM-DD HH:mm:ss.SSS')
                    : '-'
              ]);
            });

            const respCases = Object.values(groupedTestCases).filter(tc => tc.Type === "resp");
            const reqCases = Object.values(groupedTestCases).filter(tc => tc.Type === "req");

            const generateTestCaseTable = (title, testCases) => {
              if (!testCases.length) return;

              doc.setFontSize(14);
              doc.text(title, 14, yOffset);
              yOffset += 6;

              const tableData = testCases.map(test => [
                test.IdTestCase,
                test.CaseSumary,
                getStatusLabel(test.Status, this),
                test.ExecutionDate && test.ExecutionDate !== '-'
                    ? moment.utc(test.ExecutionDate).local().format('YYYY-MM-DD HH:mm:ss.SSS')
                    : '-'
              ]);

              doc.autoTable({
                head: [[this.$t('account_tb.test_case_id'), this.$t('account_tb.description'), this.$t('account_tb.status_report'), this.$t('account_tb.execution_date')]],
                body: tableData,
                startY: yOffset,
                theme: "striped",
                margin: { left: 14, right: 14 },
                styles: { fontSize: 10 }
              });

              yOffset = doc.lastAutoTable.finalY + 10;
            };

            generateTestCaseTable(this.$t('account_tb.type_case_resp'), respCases);
            generateTestCaseTable(this.$t('account_tb.type_case_req'), reqCases);

            doc.setFontSize(16);
            doc.text(this.$t('account_tb.details_test_case_and_dataset'), 14, yOffset);
            yOffset += 10;

            Object.values(groupedTestCases).forEach(testCase => {
              doc.setFontSize(12);
              doc.text(`${this.$t('account_tb.test_case_id')}: ${testCase.IdTestCase} - ${testCase.CaseSumary}`, 14, yOffset);
              yOffset += 6;

              doc.autoTable({
                head: [[this.$t('account_tb.id_dataset'), this.$t('account_tb.description'), this.$t('account_tb.status_report'), this.$t('account_tb.execution_date')]],
                body: testCase.Datasets,
                startY: yOffset,
                theme: "grid",
                margin: { left: 20, right: 14 },
                styles: { fontSize: 10 }
              });

              yOffset = doc.lastAutoTable.finalY + 12;
            });

            const pageCount = doc.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
              doc.setPage(i);
              doc.setFontSize(10);
              doc.text(`Dealprudence - EPC ART platform for VOP`, 65, 287);
              doc.text(`Page ${i} / ${pageCount}`, 190, 287, { align: 'right' });
            }

            const fileName = `${this.$t('account_tb.report_test_cases_pdf')}_${companyName}_${Date.now()}.pdf`;
            // doc.save(fileName);

            const base64String = doc.output('datauristring').split(',')[1];
            this.$engine.accountTB.generatePDFSigned({ base64String })
                .then(resp => {
                  const byteCharacters = atob(resp.data);
                  const byteArray = new Uint8Array([...byteCharacters].map(c => c.charCodeAt(0)));
                  const blob = new Blob([byteArray], { type: "application/pdf" });
                  const link = document.createElement("a");
                  link.href = URL.createObjectURL(blob);
                  link.download = fileName;
                  link.click();
                  URL.revokeObjectURL(link.href);
                })
                .catch(error => {
                  this.activateSpinner = false;
                  errorMessageAlert(error, this);
                });
          })
          .catch(err => {
            console.error('Erreur logo :', err);
          });
    },
    getDate(date){
      return moment.utc(date).local().format('YYYY-MM-DD HH:mm:ss.SSS')
    },
    getTestCaseName (name) {
      if (this.$i18n.t('toolbox.req_summary_case.' + name) !== 'toolbox.req_summary_case.' + name) {
        return this.$i18n.t('toolbox.req_summary_case.' + name)
      } else if (this.$i18n.t('toolbox.resp_summary_case.' + name) !== 'toolbox.resp_summary_case.' + name) {
        return this.$i18n.t('toolbox.resp_summary_case.' + name)
      }
      return name ? name : ''
    },
    onClear () {
      this.filterBy = ''
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    onRefresh () {
      this.fetchTestTB()
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    refreshInbox () {
      this.onRefresh()
    },
    reOrderBy (column) {
      this.TestCaseTBList = []
      let that = this
      if (this.sortField === column) {
        this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC'
      } else {
        this.sortField = column
        switch (column) {
          case 'dateAction':
            this.sortDirection = 'DESC'
        }
      }
      let filterConditions

      // if (this.id !== 'NULL'){
      //   filterConditions.IdBulk = this.id
      // }
      this.$engine.accountTB.getAccountTB(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResultsTotal = resp.data.countTestCaseTBs
        that.paginationObject.nbResults = resp.data.tracks.length
        requests = resp.data
        that.updateInbox(requests, false)
        that.$f7.pullToRefreshDone()
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    updateInbox (requests, noAttach = false) {
      this.TestCaseTBList = requests.accounts
      if (requests.accounts.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    svgToBase64Image(url) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.crossOrigin = 'anonymous'
        img.onload = function () {
          const canvas = document.createElement('canvas')
          canvas.width = img.width
          canvas.height = img.height
          const ctx = canvas.getContext('2d')
          if (!ctx) return reject('Canvas context null')
          ctx.drawImage(img, 0, 0)
          resolve(canvas.toDataURL('image/jpg'))
        }
        img.onerror = reject
        img.src = url
      })
    }
  }
}
</script>

<style scoped>
.result-vignette {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
}

.result-mtch {
  background-color: rgba(0, 143, 57, 0.8);
}

.result-nmtc {
  background-color: rgba(204, 0, 0, 0.8);
}

.result-cmtc {
  background-color: rgba(230, 159, 0, 0.8);
}

.result-noap {
  background-color: rgba(153, 153, 153, 0.8);
}
</style>
